import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({
  title,
  description,
  keywords = '',
  ogImage = '/assets/images/og-default.jpg',
  canonicalUrl,
  schemaData,
  breadcrumbs, meta
}) => {
  const siteUrl = import.meta.env.VITE_APP_SITE_URL || 'https://bootminds.com';
  const fullCanonicalUrl = canonicalUrl ? `${siteUrl}${canonicalUrl}` : `${siteUrl}${window.location.pathname}`;
  const fullOgImage = ogImage.startsWith('http') ? ogImage : `${siteUrl}${ogImage}`;

  // Generate breadcrumb schema
  const breadcrumbSchema = breadcrumbs ? {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((crumb, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": crumb.name,
      "item": `${siteUrl}${crumb.url || crumb.href || ''}`
    }))
  } : null;

  // Organization schema
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Bootminds Elite",
    "description": "The definitive authority for enterprise clients establishing Global Capability Centers in India",
    "url": siteUrl,
    "logo": `${siteUrl}/assets/images/White_logo_-_no_background-1753075265135.png`,
    "sameAs": [
    "https://www.linkedin.com/company/bootminds-elite"],

    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Executive Contact",
      "email": "executive@bootminds.com"
    }
  };

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullCanonicalUrl} />

      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullOgImage} />
      <meta property="og:url" content={fullCanonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Bootminds Elite" />

      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullOgImage} />

      {/* Additional SEO Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Bootminds Elite" />
      <meta name="language" content="en" />
      <meta name="revisit-after" content="7 days" />

      {/* JSON-LD Schema Markup */}
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      
      {breadcrumbSchema &&
      <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      }

      {schemaData &&
      <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
      }
    </Helmet>);

};

export default SEOHead;